export function tableConfig(getMoney) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    index: true,
    indexLabel: "序号",
    indexLabelWidth: 35,
    refreshBtn: true,
    searchShow: false,
    showSummary: true,
    selection: true,
    selectionWidth: 35,
    border:true,
    sumColumnList: [{
      label: '',
      name: 'factoringCredit',
      type: 'sum'
    }, {
      label: '',
      name: 'alreadyInvestAmount',
      type: 'sum'
    }, {
      label: '',
      name: 'commission',
      type: 'sum'
    }, {
      label: '',
      name: 'cleanMoney',
      type: 'sum'
    }, {
      label: '',
      name: 'otherAmount',
      type: 'sum'
    }],
    column: [{
        label: "项目名称",
        placeholder: "请输入项目名称",
        search: true,
        prop: "investName",
        width: "240",
        slot: true,
        overHidden: true,
      },
      // {
      //     label: '保理类型',
      //     prop: "projectTypeStr",
      //     width: '150'
      // },
      // {
      //     label: "客户名称",
      //     placeholder: "请输入客户名称",
      //     search: true,
      //     prop: "custName",
      //     width: "180",
      //     overHidden: true,
      //     display:false,
      //     hide:true,

      // },
      {
        label: "客户名称",
        placeholder: "请输入客户名称",
        search: true,
        prop: "custName",
        width: "180",
        overHidden: true,
        display: false,
        hide: true,

      },
      {
        label: "客户名称",
        placeholder: "请输入客户名称",

        prop: "sellerCustName",
        width: "180",
        overHidden: true,

      },
      {
          label: '审批状态',
          prop: "auditStatus",
          type: "select",
          dicUrl: '/api/blade-system/dict-biz/dictionary?code=project_build_state',
          props: {
          label: "dictValue",
          value: "dictKey"
          },      
          search: true,
          hide: true
      },
      {
        label: '保理合同',
        prop: 'contractName',
        overHidden: true,
        search: true,
        width: '200'
      }, 
      {
        label: '日期范围',
        prop: 'timePic',
        type:'daterange',
        searchSpan:12,
        searchRange:true,
        search:true,
        hide:true
      }, 
      {
        label: '款项标题',
        prop: 'investName',
        overHidden: true,
        width: '200'
      }, {
        label: '合同金额',
        prop: 'contractMoney',
        overHidden: true,
        width: '150',
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }

      }, {
        label: '已投放金额',
        prop: 'alreadyInvestAmount',
        overHidden: true,
        width: '150',
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      }, {
        label: '手续费',
        width: '150',
        prop: 'commission',
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      }, {
        label: '净投放金额(元)',
        prop: 'cleanMoney',
        width: '150',
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      }, {
        label: '内部收益率',
        prop: 'xirrStr'
      }, {
        label: '可用额度',
        prop: 'otherAmount',
        width: '150',
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      }, {
        label: '投放申请状态',
        prop: 'auditStatusStr',
        width: '150'
      }, {
        label: '业务主办',
        prop: 'managerUserName'
      }, {
        label: '业务协办',
        prop: 'assistUserName'
      }, {
        label: '所属部门',
        width: '180',
        overHidden: true,
        prop: 'managerDeptName'
      },
      // {
      //     label: '合同期限',
      // },
      // {
      //     label: '投放审批表',
      // },
      {
        label: '创建时间',
        width: '180',
        prop: 'createTime',
        overHidden: true
      }
    ]
  }
}

export function filterConfig() {
  return {

  }
}

export function addFormOne() {
  return {
    labelWidth: 130,
    emptyBtn: false,
    submitBtn: false,
    column: [{
      label: "项目名称",
      prop: "name",
      formslot: true,
      disabled: false,
      placeholder: "等待生成项目名称",
      rules: [{
        required: true,
        message: "请选择项目",
        trigger: "change"
      }]
    }, {
      label: '业务类型',
      prop: "projectTypeStr",
      disabled: true
    }, {
      label: '项目融资额度',
      prop: "factoringCreditStr",
      disabled: true,
      append: '元'
    },
    // {
    //   label: '已用额度',
    //   prop: "usedFinancingQuota",
    //   disabled: true,
    //   append: '元'
    // }, {
    //   label: '可用额度',
    //   prop: "usableFinancingQuota",
    //   disabled: true,
    //   append: '元'
    // }, 
    {
      label: '业务主办',
      prop: "managerUserName",
      disabled: true
    }, {
      label: '业务协办',
      prop: "assistUserName",
      disabled: true
    }]
  }
}

export function addFormTwo() {
  return {
    labelWidth: 130,
    emptyBtn: false,
    submitBtn: false,
    column: [{
        label: "保理合同",
        prop: "contractName",
        formslot: true,
        disabled: false,
        placeholder: "等待生成项目名称",
        rules: [{
          required: true,
          message: "请选择合同",
          trigger: "change"
        }]
      }, {
        label: "方案名称",
        prop: "quotaName",
        formslot: true,
        disabled: false,
        placeholder: "等待生成项目名称",
        rules: [{
          required: true,
          message: "请选择方案",
          trigger: "change"
        }]
      }, {
        label: "报价方案金额",
        prop: "contractFactoringCredit",
        disabled: true,
        placeholder: "等待生成项目名称",
        append: '元'
      }, {
        label: "投放金额",
        prop: "investCredit",
        disabled: false,
        append: '元'
      }, {
        label: '债权人',
        prop: "sellerCustName",
        disabled: true,
        placeholder: "选择合同和方案后回显"
      },
      // {
      //     label: '首付款',
      //     prop: "downPayment",
      //     disabled: true,
      //     placeholder: "选择合同和方案后回显",
      //     append: '元'
      // },
      // {
      //     label: '首付款收取费率',
      //     prop: "downPaymentRate",
      //     disabled: true,
      //     placeholder: "选择合同和方案后回显",
      //     append: '%'
      // }
      {
        label: '还款期限',
        prop: "leaseTerm",
        disabled: true,
        placeholder: "选择合同和方案后回显",
        append: "天"
      }, {
        label: '是否申请宽限期',
        prop: "graceFlag",
        type: "select",
        disabled: true,
        display: true,
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=is_grace_period",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        dataType: 'number',
        placeholder: "选择合同和方案后回显"
      }, {
        label: '宽限期及使用费率',
        prop: "graceInterestDayRate",
        disabled: true,
        placeholder: "选择合同和方案后回显",
      }, {
        label: '逾期使用费率',
        prop: "overdueInterestRateStr",
        disabled: true,
        placeholder: "选择合同和方案后回显",
        append: '%'
      }, {
        label: '内部收益率',
        prop: "xirr",
        disabled: true,
        placeholder: "选择合同和方案后回显",
        append: '%'
      },
      // {
      //     label: '年租息率',
      //     prop: "annualInterestRateStr",
      //     disabled: true,
      //     placeholder: "选择合同和方案后回显",
      //     append: '%'
      // },
      // {
      //     label: '其它条件',
      //     prop: "remark",
      //     disabled: true,
      //     placeholder: "选择合同和方案后回显"
      // },
      {
        label: '还款频次',
        prop: "repaymentFrequencyStr",
        disabled: true,
        placeholder: "选择合同和方案后回显"
      }
    ]
  }
}

// 本批次放款信息
export function addFormThree() {
  return {
    labelWidth: 180,
    emptyBtn: false,
    submitBtn: false,
    column: [{
      label: "放款批次",
      prop: "investBatchStr",
      formslot: true,
      disabled: false,
      span: 14,
      placeholder: "等待生成项目名称",
    }, {
      label: '本批次投放金额',
      prop: "investAmount",
      formslot: true,
      span: 14,
      disabled: false
    }, {
      label: '需内扣总金额',
      prop: "innerReduce",
      formslot: true,
      span: 14,
      disabled: false
    }, {
      label: '净投放金额',
      prop: "netInvestAmount",
      formslot: true,
      span: 14,
      disabled: false
    }, {
      label: '预计起息日',
      prop: "rentDate",
      type: 'date',
      valueFormat: 'yyyy-MM-dd',
      span: 14,
      disabled: false,
      rules: [{
        required: true,
        message: "请选择预计起息日",
        trigger: "change"
      }]
    }, {
      label: '投放条件是否已落实',
      prop: "isInvestCondition",
      type: 'radio',
      span: 14,
      dicData: [{
          label: "是",
          value: 1,
        },
        {
          label: "否",
          value: 0,
        },
      ],
      rules: [{
        required: true,
        message: "请选择投放条件是否已落实",
        trigger: "change"
      }]
    }, {
      label: '收款方银行信息',
      prop: "bankId",
      span: 14,
      formslot: true,
      rules: [{
        required: true,
        message: "请选择付款方银行信息",
        trigger: "change"
      }]
    }, {
      label: '其它投放条件',
      prop: "otherCondition",
      span: 14,
      type: 'textarea'
    }]
  }
}

export function basicInfoFormConfig() {
  return [{
      label: '项目名称',
      prop: 'projectName',
      span: '12'
    },
    {
      label: '业务类型',
      prop: 'projectTypeStr',
      span: '12'
    },
    {
      label: '项目融资额度',
      prop: 'factoringCreditStr',
      span: '12',
      unit: '元'
    },
    // {
    //   label: '已用额度',
    //   prop: 'usedFinancingQuota',
    //   span: '12',
    //   unit: '元'
    // },
    // {
    //   label: '可用额度',
    //   prop: 'usableFinancingQuota',
    //   span: '12',
    //   unit: '元'
    // },
    {
      label: '业务主办',
      prop: 'managerUserName',
      span: '12'
    },
    {
      label: '业务协办',
      prop: 'assistUserName',
      span: '12'
    }    
  ]
}

export function contractInfoConfig() {
  return [{
      label: '保理合同',
      prop: 'contractName',
      span: '12'
    },
    {
      label: '方案名称',
      prop: 'quotaName',
      span: '12'
    },
    {
      label: '报价方案金额',
      prop: 'contractFactoringCredit',
      span: '12',
      unit: '元'
    },
    {
      label: '投放金额',
      prop: 'investCredit',
      span: '12',
      unit: '元'
    },
    {
      label: '债权人',
      prop: 'sellerCustName',
      span: '12',
    },
    // {
    //     label: '首付款',
    //     prop: 'downPaymentStr',
    //     span: '12',
    //     unit: '元'
    // },
    // {
    //     label: '首付款收取费率',
    //     prop: 'downPaymentRate',
    //     span: '12',
    //     unit: '%'
    // },
    {
      label: '还款期限',
      prop: 'leaseTerm',
      span: '12',
      unit: '天'
    },
    {
      label: '是否申请宽限期',
      prop: 'graceFlagStr',
      span: '12',
    },
    {
      label: '宽限期及使用费率',
      prop: 'gracePeriodDayRate',
      span: '12',
    },
    {
      label: '内部收益率',
      prop: 'xirrStr',
      span: '12',
      unit: '%'
    },
    // {
    //     label: '年租息率',
    //     prop: 'annualInterestRate',
    //     span: '12',
    //     unit: '%'
    // },
    // {
    //     label: '其它条件',
    //     prop: "usableFinancingQuota",
    //     span: '12',
    // },
    {
      label: '还款频次',
      prop: "repaymentFrequencyStr",
      span: '12',
    }
  ]
}

export function extraFormConfig() {
  return [{
      label: "放款批次",
      prop: 'investBatchStr',
      span: '14'
    },
    {
      label: "本批次投放金额",
      prop: 'investAmount',
      span: '14',
      unit: '元'
    },
    {
      label: "需内扣总金额",
      prop: 'innerReduce',
      formatter: (row, value, label, column) => {
          return `${value.toFixed(2)}元`;
      },
      color: '#33CCB0',
      span: '14',
      unit: '元'
    },
    {
      label: "净投放金额",
      prop: 'netInvestAmount',
      color: '#33CCB0',
      span: '14',
      formatter: (row, value, label, column) => {
        return `${value.toFixed(2)}元`;
      },
      unit: '元'
    },{
      label: '预计起息日',
      prop: "rentDate",
      span: '14'
    },
    {
      label: "投放条件是否已落实",
      prop: 'isInvestConditionStr',
      span: '14'
    },
    {
      label: "收款方银行信息",
      prop: 'bankInfo',
      span: '14'
    },
    {
      label: "其它投放条件",
      prop: 'otherCondition',
      span: '14'
    }
  ]
}
